import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { GenService } from '../shared/gen-ser.service';
import { RTCToken, SearchParams, Product } from '../shared/misc-classes';
import * as JSZip from 'JSZip';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-rtc-downloader',
  templateUrl: './rtc-downloader.component.html',
  styleUrls: ['./rtc-downloader.component.css']
})
export class RtcDownloaderComponent implements OnInit {

  searchOptions:SearchParams = {
                       "filterManfDate":false,
                       "manfFromDate":new Date(),
                       "manfToDate":new Date(),
                       "plantId":"inbt",
                       "serialOptSelection":"na",
                       "pastedSerialNosStr":"",
                       "fromSerialNo":"",
                       "toSerialNo":"",
                       "extractedSerialNumbers":[],
                       "serialExtractMessage":"",
                       "serialNos":[]
                      }

  showRTCFiles:boolean = false;

  rtcTokens:Array<RTCToken> = [];
  isSearching:boolean = false;
  isDownloadMode:boolean = false;
  isDownloadComplete:boolean = false;
  
   zip = new JSZip();

   _downloadProductList:Array<Product> = []
  
  constructor(private _dataService: DataService) { }

  ngOnInit() {
    this._downloadProductList = this._dataService.downloadProductList;
  }

  getSelectedProductRTCFolders():Array<string>{
    let _rtcFolders:Array<string> = [];
    this._downloadProductList.forEach((_prod:Product) => {
      if(_prod.isSelected == true){
        _rtcFolders.push(_prod.rtcFolder);
      }
    });
    return _rtcFolders;
  }
  searchRTCFiles(){
    let _rtcFolders:Array<string> = this.getSelectedProductRTCFolders();
    if(_rtcFolders.length == 0){
      alert('Please select atleast one Product to continue.');
      return;
    }

    if(this.searchOptions.serialNos.length == 0 && this.searchOptions.filterManfDate == false){
      alert('Please select atleast Manufacturing Date Filter or Serial Number to continue.');
      return;
    }
    this.showRTCFiles = true;
    this.searchSerialNumbers(_rtcFolders);  
  }
  showSearchParams(){
    this.showRTCFiles = false;
  }
  getPlaceHolders(){
    let _colspan:number = 4;
    let _phold_count:number = (_colspan - (this._downloadProductList.length % _colspan));
    if(_phold_count == _colspan) return [];

    let _retArray:Array<Number> = [];
    for(var i = 0; i < _phold_count; i++){
      _retArray.push(i);
    }
    return _retArray;
  }
  searchSerialNumbers(_rtcFolders:Array<string>){
    let searchManfDate:boolean = this.searchOptions.filterManfDate;
    let fromDateNum:number = 0;
    let toDateNum:number = 0;
    if(searchManfDate == true){
      fromDateNum = GenService.getDateNum(this.searchOptions.manfFromDate);
      toDateNum = GenService.getDateNum(this.searchOptions.manfToDate);
    }
    this.isSearching = true;
    this._dataService.searchSerialNumbers(searchManfDate, fromDateNum, toDateNum, "0", this.searchOptions.serialNos, _rtcFolders)
                     .subscribe((_retVal:Array<RTCToken>) => {
                       if(_retVal == null){
                         this.rtcTokens = [];
                       }
                       else{
                         this.rtcTokens = _retVal;
                       }
                      this.isDownloadMode = false;    
                      this.isSearching = false;
                  });
  }

  getSerialCountMessage(){
    if(this.rtcTokens.length < 5000)
      return "Showing " + this.rtcTokens.length + " RTC files.";
    else
      return "Showing " + this.rtcTokens.length + " of many, please narrow down your search.";
  }

  displayFile(_rtcFile:RTCToken){
    this._dataService.downloadFile(_rtcFile.relPath,_rtcFile.serialNo);
    
 
    // zip.file("Hello.txt", "Hello World\n");
    
    // var img = zip.folder("images");
    // img.file("smile.gif", "", {base64: true});
    
    // zip.generateAsync({type:"blob"}).then(function(content) {
    //     // see FileSaver.js
    //     saveAs(content, "example.zip");
    // });
  }

  totalDownloadCount:number = 0;
  downloadFileIndex:number = 0;
  downloadZip(){
    this.downloadFileIndex = 0;
    this.isDownloadMode = true;
    this.isDownloadComplete = false;
    this.totalDownloadCount = this.rtcTokens.length;
    this.zip = new JSZip();
    this.startDownload();
  }

  startDownload(){
    if(this.downloadFileIndex < this.totalDownloadCount){
      let _rtcToken:RTCToken = this.rtcTokens[this.downloadFileIndex];
      
      this._dataService.downloadFileContent(_rtcToken.relPath,_rtcToken.serialNo)
          .subscribe((_resp:any) => {
            this.zip.file(_rtcToken.serialNo + ".pdf", _resp._body,{binary:true});
            this.downloadFileIndex++;
            setTimeout(() => {
              this.startDownload();  
            }, 1);
          });
    }
    else{
      this.zip.generateAsync({type:"blob"}).then((content) => {
        // see FileSaver.js
        saveAs(content, "RTC-downloads.zip");
        this.isDownloadMode = false;
        this.isDownloadComplete = true;
      });
    }
  }
  

  toUTF8Array(str) {
    var utf8 = [];
    str = str[10];
    for (var i=0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        console.log(charcode);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
            utf8.push(0xc0 | (charcode >> 6), 
                      0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
            utf8.push(0xe0 | (charcode >> 12), 
                      0x80 | ((charcode>>6) & 0x3f), 
                      0x80 | (charcode & 0x3f));
        }
        // surrogate pair
        else {
            i++;
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charcode = 0x10000 + (((charcode & 0x3ff)<<10)
                      | (str.charCodeAt(i) & 0x3ff))
            utf8.push(0xf0 | (charcode >>18), 
                      0x80 | ((charcode>>12) & 0x3f), 
                      0x80 | ((charcode>>6) & 0x3f), 
                      0x80 | (charcode & 0x3f));
        }
    }
    return utf8;
}

  getDownloadStatus(){
    if(this.downloadFileIndex >= this.totalDownloadCount){
      return "Download finished, preparing zip archive, please wait";
    }
    return "Downloading " + (this.downloadFileIndex + 1) + " of " + this.totalDownloadCount +" files, please wait...";
    
  }
}
